export const WARNING_ICON_COLOR = "#FFB84E";
export const WARNING_ICON_COLOR_LIGHTER = "#FFD87E";
export const SUCCESS_ICON_COLOR = "#0ABF53";

/** Violet for scheduled publication / availability states (distinct from accent link color) */
export const SCHEDULED_COLOR = "oklch(60.6% 0.25 292.717)";

/** Background tint for scheduled-state callouts */
export const SCHEDULED_BACKGROUND_COLOR = "oklch(95% 0.03 292.717)";
